import React from 'react';
import { useDataAttrs } from 'Helpers/Testing';
import { FDStack, FDCurrencyInput, FDAlert } from '@facet-wealth/design';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import Slider from '@mui/material/Slider';
import { currency } from 'Helpers/Formats';

export function MonthlySurplusSliderWithText({
  disabled,
  error,
  helperTextValue,
  label,
  onChange,
  placeholder,
  readonly,
  required,
  value,
  min,
  max,
  labelPlacement,
  roundToDollar,
  surplusTooHighText,
  ...rest
}) {
  return (
    <>
      <FDStack direction="column" paddingX={3}>
        <Slider
          value={Math.max(value, 0)}
          disabled={disabled || readonly || value < 0}
          onChange={(_, val) => onChange(val?.toString())}
          valueLabelDisplay="off"
          getAriaValueText={(val) => currency(val, roundToDollar)}
          min={0}
          max={max}
        />
      </FDStack>
      <FDStack direction="column" spacing={2}>
        <FDCurrencyInput
          {...useDataAttrs(rest)}
          showCents={!roundToDollar}
          disabled={disabled || readonly}
          error={error}
          helperText={value > max ? undefined : helperTextValue}
          label={label}
          onChange={(val) => (onChange(val === undefined ? '' : val?.toString()))}
          placeholder={placeholder}
          min={min}
          max={max}
          labelPlacement={labelPlacement}
          required={required}
          value={value === '' ? undefined : +value}
        />
        {value > max ? (
          <FDAlert title={surplusTooHighText} status="error" />
        ) : null}
      </FDStack>
    </>
  );
}

MonthlySurplusSliderWithText.propTypes = {
  disabled: inputPropTypes.disabled,
  label: inputPropTypes.label,
  placeholder: inputPropTypes.placeholder,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  min: inputPropTypes.min,
  max: inputPropTypes.max,
  value: inputPropTypes.value.isRequired,
  onChange: inputPropTypes.onChange.isRequired,
  labelPlacement: inputPropTypes.labelPlacement,
  readonly: inputPropTypes.readonly,
  required: inputPropTypes.required,
  roundToDollar: inputPropTypes.roundToDollar,
};
